import React, { ComponentProps, HTMLAttributes } from "react";
import classNames from "classnames";
import Link from "next/link";

const Chip: React.FC<
  ComponentProps<typeof Link> | HTMLAttributes<HTMLSpanElement>
> = ({ children, className, ...others }) => {
  const classes = classNames(
    "font-bold px-md rounded-full text-xs inline-flex items-center bg-green-60 py-0.5",
    className,
  );

  const href = (others as ComponentProps<typeof Link>).href;

  const Element = href ? Link : "span";

  return (
    <Element className={classes} {...others} href={href}>
      {children}
    </Element>
  );
};

export default Chip;
